import React, { useCallback, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import "./footer.scss"
import PlaceBat2d from '../place-bat/PlaceBat2d'
import BarcodeReader from "react-barcode-reader";
import { useDispatch, useSelector } from 'react-redux';
import { SHOW_MAIN_ERROR_MODAL } from '../../../redux/errorMessageSlice';
import { SET_ADVANCE_DRAW_SELECT_TIME, SET_CLAIM_TICKET_ID } from '../../../redux/2d-slice/gameInfo2dSlice';
import { RESET_SLICE_STATE, SET_ACTIVE_SERIES_INDEX, SET_ACTIVE_SERIES_PART_INDEX, SET_LAST_INPUT_CHANGE_RECORD, SET_PREVIEWS_ACTIVE_SERIES_DETAIL, SET_SERIES_PART_CHECKED, SET_SERIES_STORE, SelecrSeriesStore } from '../../../redux/2d-slice/seriesSlice2d';
import { setAdvanceTimeSlotCount } from '../../../redux/seriesSlice';

function Footer() {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  let seriesStore = useSelector(SelecrSeriesStore)

  // Create the downHandler with useCallback to prevent unnecessary recreations
  const downHandler = useCallback((e) => {
    let { key } = e

    if (key === 'F5') {
      e.preventDefault()
      dispatch(RESET_SLICE_STATE());
      dispatch(SET_ADVANCE_DRAW_SELECT_TIME([]))
    }
    if (key === 'F1') {
      navigate('resultModal2d')
    }
    if (key === 'F3') {
      navigate('reprint')
    }
    if (key === 'F2') {
      navigate('report')
    }
    if (key === 'F4') {
      navigate('cancel-ticket')
    }
    if (key === 'F9') {
      navigate('advance')
    }
  }, [dispatch, navigate]);

  // Add the keydown event listener for F5, F6, etc.
  useEffect(() => {
    window.addEventListener("keydown", downHandler);

    return () => {
      window.removeEventListener("keydown", downHandler);
    }
  }, [downHandler]);

  useEffect(() => {
    document.addEventListener('keydown', event => {
      if (event.keyCode === 74 || event.keyCode === 2) {
        event.preventDefault();
        return false;
      }
    });
    return () => {
      document.removeEventListener('keydown', null)
    }
  }, [])

  let handleScan = (data) => {
    let ticket_id = data.slice(1)
    dispatch(SET_CLAIM_TICKET_ID(ticket_id))
    navigate('claim-ticket')
  }

  let handleError = (err) => {
    // console.log('err: ', err);
    // dispatch(SHOW_MAIN_ERROR_MODAL('Somthing went wrong'))
    // toast.error('Somthing wrong')
  }

  let resetCode = () => {
    seriesStore.forEach((series) => {
      series.AllSeriesPartName.forEach((partName) => {
        partName.active = false
      })

      series.seriesAllfield.forEach((fields) => {
        fields.forEach(field => {

          field.resetValue()
        })
      })
    })

    dispatch(SET_SERIES_STORE(seriesStore))
    dispatch(SET_ACTIVE_SERIES_INDEX(0))
    dispatch(SET_ACTIVE_SERIES_PART_INDEX(0))
    dispatch(SET_LAST_INPUT_CHANGE_RECORD())
    dispatch(SET_PREVIEWS_ACTIVE_SERIES_DETAIL({ lastSeriesIndex: null, lastSeriesPartIndex: null, isActiveSeriesName: false }))
    dispatch(SET_SERIES_PART_CHECKED(new Array(3).fill(false)))
    dispatch(SET_ADVANCE_DRAW_SELECT_TIME([]))
  }

  return (
    <>
      {/* <BarcodeReader onError={handleError} onScan={handleScan} stopPropagation={false} preventDefault={false} /> */}
      <tr className="flex">
        <th colspan="2" align="left" valign="bottom" scope="col">
          <table width="80%" border="0">
            <tbody>
              <tr>
                <th width="10%" bordercolor="#FFFFFF" bgcolor="#FFFF00" scope="col" style={{
                  textAlign: 'center',
                  borderWidth: '0px',
                  borderRadius: '15px',
                  padding: '5px 10px',
                  cursor: 'pointer',
                  backgroundColor: 'yellow',
                  color: 'black',
                }} id="PrintDv1">
                  <div align="center" id="PrintDv11">
                    <PlaceBat2d key={'footer'} /></div>
                </th>
                <th width="1%" bordercolor="#FFFFFF" bgcolor="#FFFFFF" scope="col">&nbsp;</th>
                <th width="10%" bordercolor="#FFFFFF" bgcolor="#FFFF00" scope="col" style={{
                  textAlign: 'center',
                  borderWidth: '0px',
                  borderRadius: '15px',
                  padding: '5px 10px',
                  cursor: 'pointer',
                  backgroundColor: 'yellow',
                  color: 'black',
                }} id="PrintDv3">
                  <div onClick={() => navigate('advance')} align="center">Advance</div>
                </th>
                <th width="1%" scope="col">&nbsp;</th>
                <th width="5%" bordercolor="#FFFFFF" bgcolor="#FFFF00" scope="col" style={{
                  textAlign: 'center',
                  borderWidth: '0px',
                  borderRadius: '15px',
                  padding: '5px 10px',
                  cursor: 'pointer',
                  backgroundColor: 'yellow',
                  color: 'black',
                }} onClick={() => navigate('claim-ticket')}>Claim</th>
                
              </tr>
            </tbody>
          </table>
        </th>
      </tr>
    </>
  )
}

export default Footer